const buildTimeEnvironment = {
  production: false,
  baseDomain: 'https://api.dev.atalef.ai/api/v1',
  oauthDiscoveryDocument: 'https://atalefaidev.b2clogin.com/atalefaidev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0/.well-known/openid-configuration',
  oauthIssuer: 'https://atalefaidev.b2clogin.com/218bf30f-510b-4f67-b120-0626fb278a17/v2.0/',
  oauthClientId: 'bab988b6-92c4-4200-a125-8581b6971527',
  // ssoAllowedOrigins: 'https://app.dev.atalef.ai',
  ssoAllowedOrigins: 'http://localhost:4200', // should be of code quest domain
  signalR: 'https://api.dev.atalef.ai/messagesHub',
  systemSenderId: '641ae310063633847b688414',
  googleApiKey: 'AIzaSyB8QNE6yXaEFVMHwos3cOX5cRVAcrcn3YU',
  googleGA4Key: 'G-4VRNMYSBDD',
  cloudinaryApiKey: '233688556849258',
  cloudinaryUploadPreset: 'my_preset',
  cloudinaryApiUrl: 'https://api.cloudinary.com/v1_1/dteo0axta',
  cloudinaryContentUrl: 'https://res.cloudinary.com/dteo0axta',
  cloudinaryContentFolder: 'dev',
  cloudinaryDefaultAvatar: '/assets/default-avatar_nrwx0l.svg',
  telegramBot: 'https://t.me/DevJobRadioBot',
  telegramChannel: 'https://t.me/atalefjobs',
  telegramActive: true,
  skillsValidation: true,
  azureStorageSasUrl: 'https://atalefdevtemp.blob.core.windows.net/cv-upload?sv=2023-01-03&st=2025-05-06T08%3A41%3A23Z&se=2100-01-01T08%3A41%3A00Z&sr=c&sp=racwdxltf&sig=PQl%2BnRzw2cW8L6F%2FAaOBtGFyclM6HmKkpv%2FKuAqRn2U%3D',
  azureStorageContainerName: 'cv-upload',
  // chargebeeSite: 'atalef-test', // Replace with your Chargebee site name
  // chargebeePublishableKey: 'test_YOUR_PUBLISHABLE_KEY', // Replace with your actual key
  chargebeeSite: 'atalef-bravo-test',
  chargebeePublishableKey: 'test_zjUg8wLkt6OVtrXE4bVUdzDOeZ1jfu7r',
  chargebeeMockMode: false, // Set to true to test UI without backend API
  debugResources: true, // Set to true to show missing translation keys in [brackets]
};

// Safely get runtime environment or fallback to build-time values
function getRuntimeEnvironment() {
  // Check if we're in a browser environment and window.env exists
  if (typeof window !== 'undefined' && window["env"]) {
    // Merge runtime values with build-time fallbacks
    return {
      ...buildTimeEnvironment,
      ...window["env"]
    };
  }
  // Return build-time values if window.env is not available
  return buildTimeEnvironment;
}

export const environment = getRuntimeEnvironment();
